import React from "react";
import Hero from "../components/Hero";
import PackageSelect from "../components/PackageSelect";
import Features from "../components/Features";
import AddOns from "../components/AddOns";
import Gallery from "../components/Gallery";
import CTABanner from "../components/CTABanner";
import BookingForm from "../components/BookingForm";
import PaymentOptions from "../components/PaymentOptions";
import Testimonials from "../components/Testimonials";
import TrustReviews from "../components/TrustReviews";
import FAQ from "../components/FAQ";

function Home() {
  return (
    <>
      <Hero />
      <PackageSelect />
      <Features />
      <AddOns />
      <Gallery />
      <CTABanner />
      <BookingForm />
      <PaymentOptions />
      <Testimonials />
      <TrustReviews />
      <FAQ />
    </>
  );
}

export default Home;
